import React from 'react';
import PropTypes from 'prop-types';

/**
 * CardContent - A simple HTML replacement for Bloomer's CardContent component
 * Uses the same class names as Bloomer for perfect CSS compatibility
 */
export function CardContent({
  className = '',
  children = null,
  tag: Tag = 'div',
  ...rest
}) {
  // Build the class name string based on props
  let classNames = 'card-content';
  
  if (className) {
    classNames += ` ${className}`;
  }

  return (
    <Tag className={classNames} {...rest}>
      {children}
    </Tag>
  );
}

CardContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

CardContent.defaultProps = {
  className: '',
  children: null,
  tag: 'div',
};

export default CardContent;
